











import { defineComponent, onUnmounted, ref } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import UserSubscribeModal from "@/components/UserSubscribeModal";
import SubscriptionOfferCard from "../SubscriptionOfferCard";

export interface SubscriptionOfferOptions {
  showTitle?: boolean;
}

export default defineComponent({
  name: "SubscriptionOffer",
  components: { SubscriptionOfferCard, UserSubscribeModal },
  props: {
    user: { type: Object as () => UserPublicData, required: true },
  },
  setup() {
    const showSubscriptionOffer = ref(false);
    const showSubscriptionList = ref(false);
    const subscriptionOfferOptions = ref<SubscriptionOfferOptions>({});

    const handleEvents = (data: SubscriptionOfferOptions = {}) => {
      subscriptionOfferOptions.value = data;
      showSubscriptionOffer.value = true;
      emitter.off<SubscriptionOfferOptions>(EVENTS.SUBSCRIPTION_OFFER_SHOW, handleEvents);
    };

    const onSubscriptionOffer = (value: boolean) => {
      showSubscriptionOffer.value = false;
      showSubscriptionList.value = value;
    };

    emitter.on<SubscriptionOfferOptions>(EVENTS.SUBSCRIPTION_OFFER_SHOW, handleEvents);
    onUnmounted(() => {
      emitter.off<SubscriptionOfferOptions>(EVENTS.SUBSCRIPTION_OFFER_SHOW, handleEvents);
    });

    return {
      showSubscriptionOffer,
      showSubscriptionList,
      subscriptionOfferOptions,
      onSubscriptionOffer,
    };
  },
});
